import React from "react";
import highlight from "libraries/highlight";
import highlightRichText from "libraries/highlightRichText";
import I18n from "i18n";
import dayjs from 'libraries/dayjs'
import DateFormatter from "../libraries/dateFormatter";
import { renderArticleTitle } from "./DatalakeDetailView";

interface Props {
  agentResult: any; // Backbone.Model (AgentResult)
  isOwnedAgentResult: boolean;
  onRestore: () => void;
}

export default function DatalakeTrashBinResult({
  agentResult,
  isOwnedAgentResult,
  onRestore,
}: Props) {
  const sourceInfo = agentResult.get("primary_source");
  const aggregationTime = agentResult.get("created_at");
  const title = agentResult.get("title");
  const languages = agentResult.get("languages") || [];
  const text = agentResult.get("text");
  const richText = agentResult.richText
    ? agentResult.richText()
    : agentResult.get("rich_text");
  const highlightedText = richText
    ? highlightRichText(richText)
    : highlight(text || "");

  const formattedAggregationDate = DateFormatter.formatRelativeDateTime(
    dayjs(aggregationTime),
  );

  return (
    <div data-datalake-trash-bin-view>
      <div className="lightened-container lifted-container pvs phm">
        <div className="clip-detail">
          <span className="clip-detail__timestamp">
            {formattedAggregationDate}
          </span>
          <div className="source">
            <div className="source__agent">
              <img
                src={sourceInfo.favicon_url}
                alt=""
                className="source__agent-icon"
              />
              <div className="dropdown">
                <span className="source__name">{sourceInfo.name}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="clip-detail__head">
          <h1 className="heading-xlarge">
            {renderArticleTitle(sourceInfo?.clip_url, languages, title)}
          </h1>
        </div>

        <div className="clip-detail__body pbm">
          {richText ? (
            <div
              className="hyphenate"
              dangerouslySetInnerHTML={{ __html: highlightedText }}
            />
          ) : (
            <p
              className="hyphenate"
              dangerouslySetInnerHTML={{ __html: highlightedText }}
            />
          )}
        </div>

        {isOwnedAgentResult && (
          <div className="action-bar">
            <div className="col1of2">&nbsp;</div>
            <div className="col1of2">
              <div className="action-bar__action">
                <a
                  onClick={onRestore}
                  className="button--primary button button--block"
                >
                  {I18n.t("webapp.agents.trash_bin.restore")}
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
